import { } from '@vue/composition-api'

export default function DropdownCommercial (props, context) {
  const filteredUserModules = props.data.filter(x => x.type === 'COMMERCIAL')

  return {
    filteredUserModules
  }
}



// WEBPACK FOOTER //
// ./src/app/nav_bar/compositions/DropdownCommercial.js